define(
    'viewmodels/ViewModelNotification',[
        "durandal/system",
        "durandal/app",
        "durandal/activator",
        "plugins/router",
        "services/config",
        "services/log",
        "services/session",
        "services/eventbroker"
    ],
    function(system, app, activator, router, config, log, session, eventBroker) {

        function ViewModelNotification(impl) {
            var self = this;

            self.notifications = ko.observableArray([]);
            self.isNotification = ko.computed(function () {
                return self.notifications().length != 0;
            });
            self.clearNotifications = function () {
                self.notifications([]);
            };
            self.notificationType = ko.observable('');
            self.notify = function (type, message) {
                if (arguments.length == 1) {
                    self.clearNotifications();

                    var r = arguments[0];
                    for (var i = 0; i < r.length; i++) {
                        self.notify(r[i].level, r[i].phrase);
                    }
                }

                if (arguments.length == 2 && (type != 'undefined' && message != 'undefined')) {
                    var t;

                    switch (type) {
                        case 1: t = 'alert-success'; break;
                        case 2: t = 'alert-warning'; break;
                        case 3: t = 'alert-danger'; break;
                        case 'error': t = 'alert-danger'; break;
                        case 'warning': t = 'alert-warning'; break;
                        case 'information': t = 'alert-info'; break;
                        case 'success': t = 'alert-success'; break;
                        default: t = 'alert-info';
                    }

                    self.notificationType(t);
                    self.notifications.push({ message: message });

                    tagForClearance(self.notifications().length, 10);

                    function tagForClearance(count, delay) {
                        var hwnd = setTimeout(function () {
                            if (self.notifications().length == count) {
                                self.clearNotifications();
                            }
                            if (self.notifications().length != count) {
                                //self.notifications().splice(self.notifications().length - count - 1, count);

                                clearTimeout(hwnd);
                            }
                        }, delay * 1000);
                    }
                }
            };
            self.closeNotification = function () {
                self.clearNotifications();
            };

            self.app = app;
            self.system = system;
            self.config = config;
            self.log = log;
            self.session = session;
            self.eventBroker = eventBroker;
            self.deferredAttached = function () { return true; };
            self.deferredCompositionComplete = function () { return true; };
            self.codeBehind = null;
            if (impl) {

                if (_.has(impl, "attached")) {
                    self.deferredAttached = impl.attached;
                    delete impl.attached;
                }

                if (_.has(impl, "compositionComplete")) {
                    self.deferredCompositionComplete = impl.compositionComplete;
                    delete impl.compositionComplete;
                }

                $.extend(self, impl);
            }

            var codeBehindLoaded = $.Deferred();
            self.codeBehindLoaded = codeBehindLoaded.promise();

            
            // Defer anything event related, because we need to wait for Durandal to assign the module id.
            _.defer(function() {

                if (self.hasCodeBehind) {
                    // Presumes that we're using convention - should use the view locator ideally.
                    var codeBehindPath = system.getModuleId(self).replace("viewmodels", "views") + ".html";

                    require([codeBehindPath], function(codeBehind) {
                        self.codeBehind = codeBehind;
                        codeBehindLoaded.resolve();
                    });

                } else {
                    codeBehindLoaded.resolve();
                }


            });
        }

        ViewModelNotification.prototype.attached = function () {
            var self = this;
            var dfd = $.Deferred();
            var args = _.toArray(arguments);

            self.codeBehindLoaded.done(function () {
                var resultOrPromise = self.deferredAttached();
                if (resultOrPromise) {
                    if (system.isPromise(resultOrPromise)) {
                        resultOrPromise.done(function () {
                            if (self.codeBehind && _.has(self.codeBehind, "attached")) {
                                self.codeBehind.attached.apply(self.codeBehind, args);
                            }
                            dfd.resolve();
                        });
                    } else {
                        if (self.codeBehind && _.has(self.codeBehind, "attached")) {
                            self.codeBehind.attached.apply(self.codeBehind, args);
                        }
                        dfd.resolve();
                    }
                };
            });

            return dfd.promise();
        };

        ViewModelNotification.prototype.compositionComplete = function () {
            var self = this;
            var args = _.toArray(arguments);

            self.codeBehindLoaded.done(function () {
                var resultOrPromise = self.deferredCompositionComplete();
                if (resultOrPromise) {
                    if (system.isPromise(resultOrPromise)) {
                        resultOrPromise.done(function () {
                            if (self.codeBehind && _.has(self.codeBehind, "compositionComplete")) {
                                self.codeBehind.compositionComplete.apply(self.codeBehind, args);
                            }
                        });
                    } else {
                        if (self.codeBehind && _.has(self.codeBehind, "compositionComplete")) {
                            self.codeBehind.compositionComplete.apply(self.codeBehind, args);
                        }
                    }
                }
            });
        };


        return ViewModelNotification;
    });
